module.exports = __webpack_public_path__ + "a69a4db1dc1ddd5e211a44bb4a53e5dc.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Regular.ttf
 ** module id = 907
 ** module chunks = 9
 **/